/* eslint-disable no-lonely-if */
import { FC, ReactNode, createContext } from 'react';
import { EmailBoxContextProps } from '../../Types/MailT';
import { useEmailFolders } from '../hooks/useEmailFolders';

export const EmailBoxContext = createContext<EmailBoxContextProps>({} as EmailBoxContextProps);

export const EmailBoxContextProvider: FC<{ contactIds?: number[]; children: ReactNode }> = ({
  contactIds,
  children,
}) => {
  const value = useEmailFolders(contactIds);

  return <EmailBoxContext.Provider value={value}>{children}</EmailBoxContext.Provider>;
};
